import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Text$1 from '../../basics/Text/Text.js';
import StyledFacts from './Facts.style.js';

const Facts = ({
  facts
}) => /*#__PURE__*/React$1.createElement(StyledFacts, {
  hasEvenNumberOfFacts: facts.length % 2 === 0
}, facts.map(({
  id,
  fact
}) => /*#__PURE__*/React$1.createElement(Text$1, {
  key: id,
  className: "facts__fact",
  content: fact
})));

Facts.propTypes = {
  facts: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string,
    fact: PropTypes$1.string
  })).isRequired
};

export default Facts;
